"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.default = {
    inputAndroid: {
        marginLeft: -4,
        paddingLeft: 4,
        height: 40,
        width: '100%',
        minWidth: '100%',
        maxWidth: '100%',
        color: 'black',
    },
    inputIos: {
        height: 32,
        width: '100%',
        minWidth: '100%',
        maxWidth: '100%',
        color: 'black',
    },
};
